import type { Product } from '@equinox/shared';

/**
 * The stock a product row shows, sorts and filters by. A product sold by
 * options counts its stock on its ACTIVE FLAVOURS (extras carry none) (no sale touches the product's
 * own count), so that total is what the table means; any other product is its
 * own count. Summed in thousandths because stock counts carry up to three
 * decimals and a float sum would show 0.30000000000000004.
 */
export function effectiveStock(product: Pick<Product, 'stockQty' | 'options'>): number {
  if (!product.options || product.options.length === 0) return product.stockQty;
  const thousandths = product.options
    .filter((o) => o.active && !o.isAddon)
    .reduce((sum, o) => sum + Math.round(o.stockQty * 1000), 0);
  return thousandths / 1000;
}
